// Checks if the user is on a mobile device
const isMobileDevice = (): boolean => {
  const regex =
    /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
  return regex.test(navigator.userAgent)
}

export default isMobileDevice
